import ContentOverlay from "../components/content_overlay";

function BooksPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Books</h2>}
      text_content={
        <ol>
          <li style={{ fontSize: "1.2em" }}>
            <strong>Flowering Plants of Kerala&nbsp;A Handbook (2006)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Nayar, Themath Soman &amp; Beegam, Ali &amp; Mohanan,
            Narayanan Nair &amp; Rajkumar, G
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Tropical Botanic Garden and Research Institute
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Botanical Survey of India (2005)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Editor: G. V. S. Murthy, P. Daniel, P. Venu
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Botanical Survey of India
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Biodiversity Documentation for Kerala (2004)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Compiler: P. S. Easa</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala Forest Research Institute
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Handbook on Invasive Plants of Kerala (2013)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: K. V. Sankaran</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala State Biodiversity Board
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Aquatic and Wetland Flora of Kerala (2016)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Raziuddin Ansari, Ji Jīja, R. Prakashkumar
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Malabar Botanical Garden and Institute for Plant Sciences
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Flora of Alappuzha District, Kerala, India (2009)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: C. N. Sunil, M. Sivadasan</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Bishen Singh Mahendra Pal Singh
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Flowering Plants of the Western Ghats, India: Dicots (2014)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: T. S. Nayar, A. Rasiya Beegam, M. Sibi
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Jawaharlal Nehru Tropical Botanic Garden and Research
            Institute
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Forest Trees of Kerala (2004)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: N. Sasidharan (Botanist)</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala Forest Research Institute
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Shola Forests of Kerala (2001)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: K. K. N. Nair, Kerala Forest Research Institute
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala Forest Department
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Handbook on Invasive Plants of Kerala (2013)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: K. V. Sankaran</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala State Biodiversity Board
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Tropical Homegardens: A Time-Tested Example of Sustainable
              Agroforestry (2006)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: B.M. Kumar, P.K.R. Nair</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Springer Netherlands</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>The Book of Indian Trees (1998)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: K. C. Sahni</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Bombay Natural History Society
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Cities and Canopies: Trees in Indian Cities (2019)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Harini Nagendra, Seema Mundoli
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Penguin Random House</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Plantation Trees (1996)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: R. K. Luna</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: International Book Distributors
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Common Trees of Kerala (2010)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Compiler: N. Sasidharan</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Kerala State Biodiversity Board
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Plant Diversity in India (2018)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: A. K. [VNV] Bhatnagar, Rupam Kapoor
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: I.K. International</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Forest Landscapes of the Southern Western Ghats, India (2020)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: B. R. Ramesh, Rajan Gurukkal
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Institut fran&ccedil;ais de Pondich&eacute;ry
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Pteridophyte Flora of the Western Ghats, South India (1991)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: B.I. Publications</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: V. S. Manickam, V. Irudayaraj
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Plant Diversity (2007)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: J. Phil Gibson, Terri R. Gibson
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Chelsea House</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Plant Conservation and Biodiversity (2007)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Alan T. Bull, David L. Hawksworth
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Springer Netherlands</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>The Diversity and Evolution of Plants</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Lorentz C. Pearson</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: CRC Press</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Diversity and Ecology of Invasive Plants (2019)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Sanjeet Kumar, Sudam Charan Sahu
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: IntechOpen</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Plant Diversity and Ecology in the Chihuahuan Desert (2020)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Editors: Irene Pisanty, Luis E. Eguiarte, Maria C. Mandujano
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Springer International Publishing
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Biodiversity of plant species in Iran (1999)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Ahmad Ghahreman, Farideh Attar
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Central Herbarium of Tehran University, Faculty of
            Science
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Biodiversity and Conservation in Forests (2019)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Diana F. Tomback</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: MDPI AG</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Diversity and Evolution of Land Plants (2012)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: M. Ingrouille</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Springer Netherlands</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Agrobiodiversity Conservation: Securing the Diversity of Crop Wild
              Relatives and Landraces (2012)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Editor: Nigel Maxted</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: CABI</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Ecology of World Vegetation (2012)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: O.W. Archibold</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Springer Netherlands</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Vanishing Flora: Endangered Plants Around the World (2010)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Publisher: H.N. Abrams</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Water Plants of the World: A Manual for the Identification of the
              Genera of Freshwater Macrophytes (1974)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Christopher D. K. Cook</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Springer Netherlands</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Medicinal Plants of South Africa (2009)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Ben-Erik Van Wyk, Bosch Van Oudtshoorn, Nigel Gericke
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Briza Publications</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Food Plants of the World: An Illustrated Guide (2005)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Ben-Erik Van Wyk</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Timber Press</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Plants of the World: An Illustrated Encyclopedia of Vascular
              Plants (2017)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Maarten J. M. Christenhusz, Michael F. Fay, Mark W. Chase
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: University of Chicago Press
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Forest Trees of South India (2004)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: S. G. Neginhal</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: S. G. Neginhal</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Red List of Threatened Vascular Plant Species in India (2003)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: C. Kameswara Rao (Prof.), B. L. Geetha, Geetha Suresh
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: ENVIS, Botanical Survey of India, Ministry of Environment
            &amp; Forests
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Endemic Vascular Plants of India (2015)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Paramjit Singh, K. Karthigeyan, P. Lakshminarasimhan,
            Sudhansu Sekhar Dash
          </p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Botanical Survey of India
          </p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              Plants, People, and Culture: The Science of Ethnobotany (2020)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>
            Author: Michael J Balick, Paul Alan Cox
          </p>
          <p style={{ fontSize: "0.9em" }}>Publisher: CRC Press</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Flora of Madhya Pradesh (Western Part) (2014)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: V.P. Singh</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Scientific Publishers</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>Carnivorous Plants (2023)</strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Dan Torre</p>
          <p style={{ fontSize: "0.9em" }}>Publisher: Reaktion Books</p>
          <p style={{ fontSize: "0.9em" }}>&nbsp;</p>

          <li style={{ fontSize: "1.2em" }}>
            <strong>
              An integrated system of classification of flowering plants (1981)
            </strong>
          </li>

          <p style={{ fontSize: "0.9em" }}>Author: Arthur Cronquist</p>
          <p style={{ fontSize: "0.9em" }}>
            Publisher: Columbia University Press
          </p>
        </ol>
      }
    />
  );
}

export default BooksPage;
